import axios from "axios";

const normalizeApiUrl = (url) => {
  const fallback = "http://127.0.0.1:8000/api";
  const baseUrl = (url || fallback).replace(/\/+$/, "");
  return baseUrl.endsWith("/api") ? baseUrl : `${baseUrl}/api`;
};

export const API_BASE_URL =
  normalizeApiUrl(
    process.env.REACT_APP_DJANGO_API_URL ||
    process.env.REACT_APP_API_BASE_URL_LOCAL
  );

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const refreshToken = localStorage.getItem("adminRefreshToken");

    if (error.response?.status !== 401 || originalRequest._retry || !refreshToken) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      const response = await axios.post(`${API_BASE_URL}/admin/token/refresh/`, {
        refresh: refreshToken,
      });
      localStorage.setItem("adminToken", response.data.access);
      originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
      return api(originalRequest);
    } catch (refreshError) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminRefreshToken");
      return Promise.reject(refreshError);
    }
  }
);

export default api;
